import { LABEL } from "components/ProfileDropdown/settingsStyles";
import { Switch } from "components/Switch";
import { useId } from "react";
import { PillChoice } from "./parts";
import type { Approvers, AskFirst, StepAction, Trigger } from "./types";

const APPROVERS: { value: Approvers; label: string }[] = [
  { value: "admins", label: "Admins" },
  { value: "tutors", label: "Tutors" },
  { value: "both", label: "Admins and tutors" },
];

/**
 * Any step's Ask first, on one line: the orange switch, and when it is on,
 * who can approve (admins, tutors, or both; admins when not set). The line
 * keeps its height either way. It pops up for the person whose action made
 * it when their role can approve; otherwise it waits in Activity under
 * Waiting for approval, and on the Tasks page of the tutors it relates to.
 */
export default function AskFirstControl({
  value,
  onChange,
}: {
  value: AskFirst;
  onChange: (next: AskFirst) => void;
  trigger: Trigger;
  action: StepAction;
}) {
  const id = `ask-first-${useId()}`;
  return (
    <div className="flex min-h-[1.875rem] flex-wrap items-center gap-x-4 gap-y-2">
      <div className="flex items-center gap-2">
        <Switch
          name={id}
          color="orange"
          checked={value.on}
          onCheckedChange={(on) => onChange({ ...value, on })}
          label="Ask first"
        >
          {null}
        </Switch>
        <label
          htmlFor={id}
          className="cursor-pointer text-sm font-semibold text-gray-900"
        >
          Ask first
        </label>
      </div>
      {value.on && (
        <div className="flex items-center gap-2">
          <span className={LABEL}>Who can approve</span>
          <PillChoice<Approvers>
            label="Who can approve"
            value={value.approvers ?? "admins"}
            options={APPROVERS}
            onChange={(approvers) => onChange({ ...value, approvers })}
          />
        </div>
      )}
    </div>
  );
}
